<template>
	<div class="module-box flex-grow">
		<div class="module-bg flex-column">
			<template>
				<div class="border-top flex">
					<div class="angle"></div>
					<div class="border flex-grow"></div>
					<div class="angle"></div>
				</div>
				<div class="border-sides flex flex-grow">
					<div class="border"></div>
					<div class="center flex-grow"></div>
					<div class="border"></div>
				</div>
				<div class="border-bottom flex">
					<div class="angle"></div>
					<div class="border flex-grow"></div>
					<div class="angle"></div>
				</div>
			</template>
		</div>
		<div class="module flex-column" :style="{'padding-top': title ? 0 : '.2rem'}">
			<div v-if="title" class="title">
				<p>{{title}}</p>
			</div>
			<div class="content flex-grow flex-column"><slot></slot></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String
		}
	}
</script>

<style lang="stylus" scoped>
	.module {
		box-sizing: border-box;
		position: relative;
		height: 100%;
		padding: 0 .2rem .2rem;

		&-box {
			position: relative;
		}
		
		&-bg {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			
			.border {
				&-top,
				&-bottom {
					min-height: .4rem;
				}
				
				&-top {
					.angle:nth-last-child(1) {
						transform: rotate(90deg);
					}
					
					.border {
						background-image: url('~@/assets/image/digital/box_border_top.png');
						background-size: 100% 100%;
					}
				}
				
				&-sides {
					.border {
						min-width: .4rem;
						background-size: 100% 100%;
							
						&:nth-child(1) {
							background-image: url('~@/assets/image/digital/box_border_left.png');
						}
						
						&:nth-last-child(1) {
							background-image: url('~@/assets/image/digital/box_border_right.png');
						}
					}
				}
				
				&-bottom {
					.angle {
						&:nth-child(1) {
							transform: rotate(-90deg);
						}
						
						&:nth-last-child(1) {
							transform: rotate(180deg);
						}
					}
					
					.border {
						background-image: url('~@/assets/image/digital/box_border_bottom.png');
						background-size: 100% 100%;
					}
				}
			}
			
			.angle {
				min-width: .4rem;
				background-image: url('~@/assets/image/digital/box_angle.png');
				background-size: 100% 100%;
			}
			
			.center {
				background: rgba(8,33,14,.6);
			}
		}
		
		.title {
			position: relative;
			box-sizing: border-box;
			height: .6rem;
			padding: 0 .32rem;
			line-height: .48rem;
			font-size: .18rem;
			color: #FFF000;
			background-image: url('~@/assets/image/digital/title.png');
			background-size: 100% .36rem;
			background-position: left center;
			background-repeat: no-repeat;
			text-shadow: 2px 2px 5px rgba(0,0,0,.4);

			.period {
				font-size: .14rem;
				color: #F3EB07;

				.tf {
					margin-right: .05rem;
				}
			}
		}
		
		.content > * {
			box-sizing: border-box;
			height: 100%;
		}
	}
</style>
